import { S } from './Shimmer.styles';
import type { ShimmerProps } from './Shimmer.types';

export const Shimmer = ({
  width,
  height,
  variant = 'text',
  animation = 'wave',
  children,
  ...otherProps
}: ShimmerProps) => (
  <S.Root
    $width={width}
    $height={height}
    variant={variant}
    animation={animation}
    hasChildren={!!children}
    {...otherProps}
  >
    {children}
  </S.Root>
);
